const MOTIVATIONAL_MESSAGES = [
  { msg: "Every word you learn is a superpower! 🦸", emoji: "🌟" },
  { msg: "Practice makes perfect — you've got this!", emoji: "💪" },
  { msg: "Great spellers are made, not born. Keep going!", emoji: "🚀" },
  { msg: "Words are the most powerful tools in the world. Use them well!", emoji: "✨" },
  { msg: "One word at a time — you're building something amazing.", emoji: "🏗️" },
  { msg: "Champions show up every day. That's you!", emoji: "🏆" },
  { msg: "Your brain grows stronger every time you practise.", emoji: "🧠" },
  { msg: "Mistakes are just steps on the way to mastery!", emoji: "📈" },
  { msg: "Today's practice is tomorrow's confidence.", emoji: "🌈" },
  { msg: "You're doing something many people never bother to do — brilliant!", emoji: "💎" },
  { msg: "Every master was once a beginner. Keep going!", emoji: "🎯" },
  { msg: "Words unlock doors — you're collecting the keys!", emoji: "🗝️" },
  { msg: "The more you learn, the more you can do. Keep it up!", emoji: "⚡" },
  { msg: "Reading + spelling + curiosity = unstoppable!", emoji: "🔥" },
  { msg: "Your future self will thank you for practising today.", emoji: "🌠" },
  { msg: "Hard words become easy words with enough practice.", emoji: "💡" },
  { msg: "You're not just spelling — you're getting smarter every session.", emoji: "🎓" },
  { msg: "Keep showing up. Progress is happening, even when you can't see it.", emoji: "🌱" },
  { msg: "Every test is a chance to shine. Go for it!", emoji: "⭐" },
  { msg: "Spelling champion in the making — right here, right now.", emoji: "🏅" },
  { msg: "The best investment you can make is in yourself. You're nailing it!", emoji: "💝" },
  { msg: "Words are everywhere — you're learning to own them!", emoji: "📚" },
  { msg: "A little practice every day adds up to big results!", emoji: "📊" },
  { msg: "You make learning look easy. Keep that energy going!", emoji: "😎" },
  { msg: "Curiosity + effort = genius. You've already started!", emoji: "🔍" },
  { msg: "Every word you master is a step toward your best self!", emoji: "🛤️" },
  { msg: "Small progress is still progress. Never give up!", emoji: "🐢" },
  { msg: "You've already beaten the hardest part — you showed up!", emoji: "🎉" },
  { msg: "Smart is not something you are — it's something you become.", emoji: "🌻" },
  { msg: "You're on a streak! The dictionary doesn't know what's coming.", emoji: "😄" },
];

export function DailyMessage({ userName, streak, bgGradient }) {
  const dayIndex = Math.floor(Date.now() / 86400000);
  const msgIndex = dayIndex % MOTIVATIONAL_MESSAGES.length;
  const { msg, emoji } = MOTIVATIONAL_MESSAGES[msgIndex];

  return (
    <div style={{
      background: bgGradient || "linear-gradient(135deg, var(--accent) 0%, var(--navy) 100%)",
      borderRadius: 16, padding: "1rem 1.25rem", marginBottom: "1.25rem",
      color: "#fff", display: "flex", alignItems: "center", gap: "1rem",
      boxShadow: "0 4px 16px rgba(0,0,0,.12)"
    }}>
      <div style={{ fontSize: "2rem", flexShrink: 0 }}>{emoji}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: ".72rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: ".08em", opacity: 0.8, marginBottom: ".2rem" }}>
          Good {new Date().getHours() < 12 ? "morning" : new Date().getHours() < 17 ? "afternoon" : "evening"}, {userName}!
        </div>
        <div style={{ fontSize: ".88rem", fontWeight: 600, lineHeight: 1.45 }}>{msg}</div>
        {streak >= 2 && (
          <div style={{ fontSize: ".75rem", marginTop: ".35rem", opacity: 0.9 }}>
            🔥 You're on a <strong>{streak}-day streak</strong> — keep it alive today!
          </div>
        )}
      </div>
    </div>
  );
}
